import { cleanCartItem, getDumbCartForMember } from '../selectors/converterSelectors'

const cart3pl = {
  list: {},
  report: {},
}

const Cart3PLReducer = function (state = cart3pl, action) {
  switch (action.type) {
    case 'UPDATE_CART_3PL': {
      return {
        ...state,
        ...action.cart,
      }
    }
    case 'UPDATE_CART_LIST_3PL': {
      const userID = action.user
      let memberCartList = {
        ...state.list[userID],
        ...action.list,
      }

      Object.entries(memberCartList).forEach(([key, value]) => {
        memberCartList[key] = cleanCartItem(memberCartList[key], memberCartList[key], 'cart')
      })

      return {
        ...state,
        list: {
          ...state.list,
          [userID]: memberCartList,
        },
      }
    }
    case 'UPDATE_CART_ITEM_3PL': {
      const userID = action.user
      const { soh, sell_by_case } = action.cartItem
      const cartItemID = action.cartItem.id
      const cartList = getDumbCartForMember(state.list, userID)
      const cartItem = cartList[cartItemID]

      let newCartItem = { ...cartItem }

      if (action.target == 'case') {
        newCartItem.caseQty = action.value
        newCartItem.caseTotal = action.value
      } else if (action.target == 'unit') {
        newCartItem.unitQty = action.value
        newCartItem.unitTotal = action.value
      } else {
        newCartItem[action.target] = action.value
      }

      if (soh > 0 && newCartItem.unitTotal == 0 && newCartItem.caseTotal == 0) {
        if (sell_by_case) {
          newCartItem.caseQty = 1
          newCartItem.caseTotal = 1
        } else {
          newCartItem.unitQty = 1
          newCartItem.unitTotal = 1
        }
      }

      newCartItem = cleanCartItem(newCartItem, newCartItem, 'cart')

      return {
        ...state,
        list: {
          ...state.list,
          [userID]: {
            ...state.list[userID],
            [cartItemID]: newCartItem,
          },
        },
      }
    }
    case 'REMOVE_CART_ITEM_3PL': {
      const { id } = action.item
      const userID = action.user
      let newList = {
        ...state.list,
        [userID]: {
          ...state.list[userID],
          ...action.list,
        },
      }

      delete newList[userID][id]

      return {
        ...state,
        list: newList,
      }
    }
    case 'CLEAR_CART_ITEM_3PL': {
      const userID = action.user
      return {
        ...state,
        list: {
          ...state.list,
          [userID]: {},
        },
      }
    }
    case 'UPDATE_CART_REPORT_3PL': {
      const userID = action.user
      return {
        ...state,
        report: {
          ...state.report,
          [userID]: action.data,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default Cart3PLReducer
